import {SystemPopup, SystemPopupPopupID} from '@gongxigames/framework/slot/types';

function sortSystemPopupsByPriority(firstPopup: SystemPopup, secondPopup: SystemPopup): number {
    const firstPopupPriority = firstPopup.priority ?? 0;
    const secondPopupPriority = secondPopup.priority ?? 0;

    if (firstPopupPriority < secondPopupPriority) {
        return 1;
    } else if (firstPopupPriority > secondPopupPriority) {
        return -1;
    } else {
        return 0;
    }
}

export class PopupsQueue {
    protected popups: SystemPopup[] = [];

    public add(popup: SystemPopup): void {
        this.popups.push(popup);
        this.popups.sort(sortSystemPopupsByPriority);
    }

    public remove(popup: SystemPopup): void {
        this.popups = this.popups.filter(({id}) => id !== popup.id);
    }

    public shiftByID(popupID: SystemPopupPopupID): SystemPopup | undefined {
        const popup = this.popups.find(({id}) => id === popupID );

        if (popup) {
            this.popups = this.popups.filter(({id}) => id !== popupID);
        }

        return popup;
    }

    public clear(): void {
        this.popups = [];
    }

    public shiftNext(): SystemPopup | undefined {
        return this.popups.shift();
    }

    public isEmpty(): boolean {
        return this.popups.length === 0;
    }
}
